export default {
  components: [
    {
      data: [
        {
          direction: 'left',
          iconName: '',
          iconUrl: 'https://static.airasia.com/design/logos/airasia-move-light.svg',
          id: 'aalogo',
          label: '',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/en/gb',
          showInMobilePane: 'FALSE',
          type: 'logo'
        },
        {
          direction: 'right',
          iconName: 'CollectionsBookmarkIcon',
          iconUrl: '',
          id: 'explore',
          label: 'Explore',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/explore',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'CollectionsBookmarkIcon',
          iconUrl: '',
          id: 'mybookings',
          label: 'My Bookings',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/search?culture=en-GB',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'PlaylistAddCheckIcon',
          iconUrl: '',
          id: 'checkin',
          label: 'Check-in',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/check-in/en/GB',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'FlightTakeoffIcon',
          iconUrl: '',
          id: 'flightstatus',
          label: 'Flight Status',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/flightstatus/en/GB',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'ForumIcon',
          iconUrl: '',
          id: 'support',
          label: 'Support',
          newTab: 'TRUE',
          redirectUrl: 'https://support.airasia.com/s/?language=en_GB',
          showInMobilePane: 'TRUE',
          type: 'navigation'
        },
        {
          direction: 'right',
          iconName: 'LanguageIcon',
          iconUrl: '',
          id: 'localecurrency',
          label: '',
          newTab: '',
          redirectUrl: '',
          showInMobilePane: 'TRUE',
          type: 'locale-currency'
        },
        {
          direction: 'right',
          iconName: 'AccountCircle',
          iconUrl: '',
          id: 'login',
          label: 'Login/Signup',
          newTab: '',
          redirectUrl: '',
          showInMobilePane: 'FALSE',
          type: 'login'
        }
      ]
    }
  ],
 
  defaultCurrency: [
    {
      data: [
        {
          icon: 'MonetizationOnIcon',
          longform: 'US Dollar',
          shortSymbol: '$',
          shortform: 'USD'
        }
      ]
    }
  ],
  defaultLocale: [
    {
      data: [
        {
          default: '/',
          icon: 'LanguageIcon',
          longform: 'Malaysia - English',
          shortform: 'EN'
        }
      ]
    }
  ],
  localeList: [
    {
      data: [
        {
          default: '/',
          longform: 'English',
          shortform: 'EN'
        },
        {
          default: '/th/th/',
          longform: 'ภาษาไทย',
          shortform: 'TH'
        },
        {
           default: '/id/id/',
           longform: 'Bahasa Indonesia',
          shortform: 'ID'
         },
  //       // {
  //       //   default: '/zh/cn/',
  //       //   longform: '简体中文',
  //       //   shortform: 'ZH'
  //       // },
  //       // {
  //       //   default: '/zh/tw/',
  //       //   longform: '繁體中文',
  //       //   shortform: 'ZH'
  //       // },
  //       // {
  //       //   default: '/zh/hk/',
  //       //   longform: '繁體中文 (香港)',
  //       //   shortform: 'ZH'
  //       // },
              {
                 default: '/ja/jp/',
                 longform: '日本語',
                 shortform: 'JA'
              },
               {
   default: '/ko/kr/',
    longform: '한국어',
   shortform: 'KO'
 },
   {
    default: '/ms/my/',
     longform: 'Bahasa Malaysia',
    shortform: 'MS'
   },
  //       // {
  //       //   default: 'vi/vn/',
  //       //   longform: 'Tiếng Việt',
  //       //   shortform: 'VI'
  //       // }
      ]
    }
  ],
  loginMenu: [
    {
      memberData: [
        {
          icon: '',
          id: 'bigMemberId',
          label: 'BIG Member ID',
          newTab: 'FALSE',
          redirectUrl: ''
        },
        {
          icon: '',
          id: 'bigMemberPoints',
          label: 'BIG Points',
          newTab: 'FALSE',
          redirectUrl: ''
        },
        {
          icon: '',
          id: 'status',
          label: 'Status',
          newTab: 'FALSE',
          redirectUrl: ''
        }
      ]
    },
    {
      navigations: [
        {
          icon: 'account_box',
          id: 'myaccount',
          label: 'My account',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/myaccount?culture=en-GB'
        },
        {
          icon: 'featured_play_list',
          id: 'mybookings',
          label: 'My bookings',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mybookings?culture=en-GB'
        },
        {
          icon: 'library_books',
          id: 'mysubscription',
          label: 'My subscription',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mysubscription?culture=en-GB'
        },
        {
          icon: 'credit_card',
          id: 'mybigpaycheckout',
          label: 'My BigPay Checkout',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/myaccount#bigpaycheckout'
        },
        {
          icon: 'assignment_turned_in',
          id: 'mycases',
          label: 'My cases',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasia.com/member/mycases?culture=en-GB'
        },
        {
          icon: 'money',
          id: 'mybigpoints',
          label: 'My BIG Points',
          newTab: 'TRUE',
          redirectUrl: 'https://www.airasiabig.com/my/en/profile'
        },
        {
          icon: 'attach_money',
          id: 'mycreditaccount',
          label: 'My credit account',
          newTab: 'TRUE',
          redirectUrl: 'https://booking2.airasia.com/CreditStatusLogin.aspx?culture=en-GB'
        }
      ]
    },
    {
      logoutButton: [
        {
          icon: '',
          id: 'logout',
          label: 'Log out',
          newTab: 'FALSE',
          redirectionUrl: ''
        }
      ]
    }
  ],
  loginTooltip: [
    {
      data: [
        {
          description: 'Log into get BIG Member discounts and also redeem your unlimited pass',
          loginButtonText: 'Log in/Sign up',
          signupButtonText: '',
          title: 'Log in now for BIG Member discounts'
        }
      ]
    }
  ],
  recommendedCurrencyList: [
    {
      data: ''
    }
  ],
  recommendedLocaleList: [
    {
      data: ''
    }
  ],
  translations: [
    {
      data: [
        {
          currency: 'Choose a currency',
          locale: 'Choose a language',
          mobileCurrencyLabel: 'Currency',
          mobileLocaleLabel: 'Language',
          otherCurrency: 'Other supported currency',
          otherLocale: 'Other supported languages',
          popularCurrency: 'Suggested currencies',
          popularLocale: 'Popular languages',
          settings: 'Settings'
        }
      ]
    }
  ]
}
